import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SecondaryMenu from '../../menu/secondaryMenu.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import {
  periodOrCurrentSelector,
  periodsSelector,
  environmentSuffixSelector,
  categoriesStaticSelector,
} from '../../shared/store/selectors';

import { changePeriod, fetchConfigurationSettingsPill, fetchConfigurationSettingsAllPills } from './store/actions';
import {
  configurationSettingsSelector,
  isLoadingConfigurationSettingsSelector,
  fetchingProgressSelector,
  countryTaxTypesSelector,
} from './store/selectors';
import DataGrid from './dataGrid.component';
import { ConfigurationSettingsPropTypes } from './propTypes';

import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector } from '../../userData/store/selectors';
import downloadConfigurationSettingsXlsx from './downloadConfigurationSettingsXlsx';
import { fetchCategories } from '../../shared/store/actions';
import { categoryPropTypes } from '../../shared/propTypes';

class ConfigurationSettingsPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,

    configurationSettings: ConfigurationSettingsPropTypes.isRequired,
    isAnyPillLoading: PropTypes.bool.isRequired,

    changePeriod: PropTypes.func.isRequired,
    fetchConfigurationSettingsPill: PropTypes.func.isRequired,
    fetchConfigurationSettingsAllPills: PropTypes.func.isRequired,

    shouldDisplayZero: PropTypes.bool.isRequired,
    hideDecimals: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
    environmentSuffix: PropTypes.string.isRequired,

    countryTaxTypes: PropTypes.arrayOf(PropTypes.shape({
      countryTaxType: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })),

    fetchCategories: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(categoryPropTypes),
  };

  constructor(props) {
    super(props);
    this.state = {
      period: props.period,
    };
  }

  componentDidMount() {
    const { fetchCategories, period } = this.props;
    fetchCategories(period.name);
  }

  componentDidUpdate(prevProps) {
    const { fetchCategories, period } = this.props;
    if (period !== prevProps.period) {
      fetchCategories(period.name);
    }
  }

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;

    const period = selectedPeriod
      ? periods.find(period => period.name === selectedPeriod.value)
      : null;

    this.setState({ period });
  };

  downloadConfigurationSettings = callback => {
    const {
      period,
      fetchConfigurationSettingsAllPills,
      categories,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    } = this.props;

    fetchConfigurationSettingsAllPills(period.name, params => {
      downloadConfigurationSettingsXlsx({
        ...params,
        categories,
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
        environmentSuffix,
      }, callback);
    });
  };

  render() {
    const {
      configurationSettings,
      fetchConfigurationSettingsPill,
      isAnyPillLoading,
      changePeriod,
      countryTaxTypes,
      categories,
    } = this.props;

    const {
      period,
    } = this.state;

    return (
      <div className="configuration-settings-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          {/* uncomment this after improving performance */}
          {/* <div className="hamburger-dropdown ml-auto text-right">
            <HamburgerDropdown
              fetchingProgress={fetchingProgress}
              downloadConfigurationSettings={this.downloadConfigurationSettings}
            />
          </div> */}
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <div className="d-flex flex-row justify-content-between">
                  <h5>Configuration</h5>
                </div>
              </div>
            </div>
            <div className="row no-gutters page-content-container">
              <div className="col">
                <DataGrid
                  data={configurationSettings}
                  period={period}
                  fetchConfigurationSettingsPill={fetchConfigurationSettingsPill}
                  changePeriod={changePeriod}
                  isLoading={isAnyPillLoading}
                  countryTaxTypes={countryTaxTypes}
                  categories={categories}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  period: periodOrCurrentSelector(state),
  periods: periodsSelector(state),

  configurationSettings: configurationSettingsSelector(state),
  isAnyPillLoading: isLoadingConfigurationSettingsSelector(state),

  shouldDisplayZero: displayZeroSelector(state),
  hideDecimals: hideDecimalsSelector(state),
  negativeMinus: negativeMinusSelector(state),
  fetchingProgress: fetchingProgressSelector(state),
  environmentSuffix: environmentSuffixSelector(state),
  countryTaxTypes: countryTaxTypesSelector(state),
  categories: categoriesStaticSelector(state),
});

export default connect(
  mapStateToProps,
  {
    changePeriod,
    fetchConfigurationSettingsPill,
    fetchConfigurationSettingsAllPills,
    fetchCategories,
  }
)(ConfigurationSettingsPage);
